module.exports = __webpack_public_path__ + "f0c0d3cb6a4eb5e95aa4f038952d8600.ttf";